import type { FC } from 'react'

import { Skeleton, SkeletonTheme } from 'shared/ui/skeleton'

import { OfferCard } from '../offer-card'

import s from './styles.module.scss'
import type { CollectionsGridLayoutProps } from './types'

const SkeletonItemsCount = 6

const CollectionsGridSkeleton = () => (
  <SkeletonTheme
    baseColor="var(--grey-32)"
    highlightColor="var(--grey-33)"
  >
    <div className={s.container}>
      {Array.from({ length: SkeletonItemsCount }).map((_, index) => (
        <div
          key={index}
          className={s.skeletonItem}
        >
          <Skeleton className={s.skeletonImage} />
          <Skeleton className={s.skeletonTitle} />
          <Skeleton className={s.skeletonPrice} />
        </div>
      ))}
    </div>
  </SkeletonTheme>
)

export const CollectionsGridLayout: FC<CollectionsGridLayoutProps> = ({
  items,
  isLoading = false,
  onSelectItem,
}) => {
  if (isLoading) {
    return <CollectionsGridSkeleton />
  }

  return (
    <div className={s.container}>
      {items.map((item) => (
        <OfferCard
          key={item.id}
          id={item.id}
          title={item.title}
          images={item.images}
          type={item.type}
          price={item.price}
          variant="grid"
          onClick={() => onSelectItem?.(item)}
        />
      ))}
    </div>
  )
}
